import React, { ForwardedRef, forwardRef } from 'react';
import { Tag as AntdTag, TagProps } from 'antd';

export type TTagProps = TagProps;

const Tag = ({ children, className, ...props }: TTagProps, ref: ForwardedRef<HTMLSpanElement>): JSX.Element => {
  return (
    <AntdTag ref={ref} {...props} className={`${className ? className : ''} template-tag`}>
      {children}
    </AntdTag>
  );
};

export default forwardRef<HTMLSpanElement, TTagProps>(Tag);
